function flightMap(flight): App.Flight {
  return {
    _links: flight._links,
    departingAirport: flight.departing_airport,
    departingAirportName: flight.departing_airport_name,
    departingDisplayNames: {
      departingCountry: flight.departing_country,
      primary: flight.departing_display_names.primary,
      secondary: flight.departing_display_names.secondary,
    },
    departingCountry: flight.departing_country,
    departingDate: flight.departing_date,
    departingTime: flight.departing_time,

    arrivalAirport: flight.arrival_airport,
    arrivalAirportName: flight.arrival_airport_name,
    arrivalDisplayNames: {
      primary: flight.arrival_display_names.primary,
      secondary: flight.arrival_display_names.secondary,
    },
    arrivalCountry: flight.arrival_country,
    arrivalDate: flight.arrival_date,
    arrivalTime: flight.arrival_time,

    operatedByText: flight.operated_by_text,
    carrier: flight.carrier,
    carrierName: flight.carrier_name,
    flightNumber: flight.flight_number,
    aircraftType: flight.aircraft_type,
    layoverTime: {
      hours: flight.layover_time.hours,
      minutes: flight.layover_time.minutes,
    },
    freeCarryOnBaggageDescription: flight.free_carry_on_baggage_description,
    freeCheckedInBaggageDescription: flight.free_checked_in_baggage_description,
    freeCheckedInBaggageIncluded: flight.free_checked_in_baggage_included,
    bookingClass: flight.booking_class,
    fareClass: flight.fare_class,
    fareBasis: flight.fare_basis,
    productClass: flight.product_class,
    operatingCarrier: flight.operating_carrier,
  }
}

export function journeyCostMap(journey) {
  return {
    cost: journey.cost,
    tax: journey.tax,
    fee: journey.fees,
    priceBreakdown: journey.price_breakdown ? {
      adults: journey.price_breakdown.adults,
      children: journey.price_breakdown.children,
      infants: journey.price_breakdown.infants,
    } : null,
  }
}

export default function journeyMap(journey): App.Journey {
  return {
    id: journey.id,
    provider: journey.provider,
    validatingCarrier: journey.validating_carrier,
    validatingCarrierName: journey.validating_carrier_name,
    validatingCarrierLogo: journey.validating_carrier_logo,
    seatSelectionPolicy: journey.seat_selection_policy,
    isAllianceCarrier: journey.is_alliance_carrier,
    apisRequired: journey.apis_required,
    auContactTracingRequired: journey.au_contact_tracing_required,
    cost: journey.cost,
    tax: journey.tax,
    fee: journey.fees,
    priceBreakdown: journey.price_breakdown ? {
      adults: journey.price_breakdown.adults,
      children: journey.price_breakdown.children,
      infants: journey.price_breakdown.infants,
    } : undefined,
    returning: journey.returning ? journeySegmentMap(journey.returning) : undefined,
    departing: journeySegmentMap(journey.departing),
    fareType: journey.fareType,
    fareClass: journey.fareClass,
    legNumber: journey.legNumber,
  }
}

function journeySegmentMap(segment): App.JourneyFlight {
  return {
    journeyKey: segment.journey_key,
    flights: segment.flights.map(flightMap),
    flightTime: {
      minutes: segment.flight_time.minutes,
      hours: segment.flight_time.hours,
    },
    extras: {
      baggage: (segment.extras && segment.extras.baggage) ? segment.extras.baggage.map(baggageMap) : [],
    },
    providerSearchId: segment.provider_searchId,
    priceBreakdown: segment.price_breakdown ? {
      adults: segment.price_breakdown.adults,
      children: segment.price_breakdown.children,
      infants: segment.price_breakdown.infants,
    } : undefined,
  }
}

function baggageMap(baggage): App.JourneyAddon {
  return {
    id: baggage.id,
    amount: baggage.amount,
    description: baggage.description,
    adult: baggage.per_adult,
    child: baggage.per_child,
  }
}
